export const CANCELLED_CONSIGNMENT_TYPE_ID = 5;

export const getAvailableConsignmentTypes = ({
  consignmentTypes = [],
  currentTypeId,
  hasWorks = false,
} = {}) => {
  if (!hasWorks) return consignmentTypes;

  const allowedTypeIds = new Set([
    Number(currentTypeId),
    CANCELLED_CONSIGNMENT_TYPE_ID,
  ]);

  return consignmentTypes.filter(type => allowedTypeIds.has(Number(type?.id)));
};
